import axios from 'axios';

import getSubmitData from './getSubmitData';
import submitFormReal from './submitFormReal';

export default function submitForm(values, {
  setSubmitting,
  onSubmit,
  onSuccess,
  setError,
  cookie,
}) {
  const submitData = getSubmitData(values, cookie);

  setSubmitting(true);
  onSubmit(true);

  // First, get the client IP address
  axios.get('https://api.ipify.org/')
    .then(({ data: ip }) => {
      submitFormReal({
        ...submitData,
        ipAddress: ip,
      }, {
        setSubmitting,
        onSubmit,
        onSuccess,
        setError,
      });
    })
    .catch(() => {
      submitFormReal(submitData, {
        setSubmitting,
        onSubmit,
        onSuccess,
        setError,
      });
    });
}
